import { Component } from "react";
import { withRouter } from "react-router-dom";

const SITE = "Illumine Digital";

// Page names by path prefix (first match wins).
const TITLES = [
  ["/auth/login", "Sign in"],
  ["/auth/register", "Register"],
  ["/auth/reset-password", "Reset password"],
  ["/code-of-conduct", "Code of conduct"],
  ["/application/channel/", "Session"],
  ["/application/unit/", "Facilitator guide"],
  ["/application", "My sessions"],
];

function titleFor(pathname) {
  const match = TITLES.find(([prefix]) => pathname.indexOf(prefix) === 0);
  return match ? `${match[1]} · ${SITE}` : `Awakened Citizen Program · ${SITE}`;
}

// Keeps document.title in step with the current route; renders nothing.
class PageTitle extends Component {
  componentDidMount() {
    document.title = titleFor(this.props.location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      document.title = titleFor(this.props.location.pathname);
    }
  }

  render() {
    return null;
  }
}

export default withRouter(PageTitle);
